import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchGetCompanySearch } from '@iwoca/lapi-client/edge_de';
import { useQuery } from '@tanstack/react-query';

export function useGetCompanySearch({
  searchQuery,
  enabled,
}: {
  searchQuery: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ['companySearch', searchQuery],
    queryFn: async () => {
      tracking.ampli.companySearchUsed({
        query_length: searchQuery.length,
      });

      return await fetchGetCompanySearch({
        query: { phrase: searchQuery },
      });
    },
    enabled: !!searchQuery && enabled,
  });
}
